import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'location_position_rate_settings',
  inputShow: gql`
    query locationPositionRateSettings($input: LocationPositionRateSettingQueryInput) {
      locationPositionRateSettings(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Rates',
    label: 'Location Position Rate Settings',
    order: 7,
  },
};
